<template>
  <BasicModal
    :title="'ロボのテンプレート化'"
    :isShowModal="isShowModal"
    :canCancel="true"
    @cancel="cancel">
    <div class="card-content">
      <p style="font-size:20px; color:#C82E42;">{{chatbot.name}}</p>
      <p></p>
      <p>テンプレートの説明：</p>
      <div class="right-col disp-scroll">
        <textarea style="margin-top: 4px; height: 100px; width: 100%;" class="textarea is-small" maxlength="300" placeholder="テンプレートの説明" v-model="chatbot.tmp_description"></textarea>
      </div>
      <div class="input-field">
        <p>タグ</p>
        <ChatBotTags
          :chatbot="chatbot"
          :isEdit="true"
          :isNew="false"
        />
      </div>
      <div style="text-align: center; margin: 8px 0px;" v-if="isSaving">
        <div>
          <span class="mdi mdi-spin mdi-loading"></span>
          アップロード中です。
          通信状況により時間がかかる場合があります。
        </div>
      </div>
    </div>
    <!-- フッターアクション -->
    <div class="footer-box">
      <button class="button" @click="cancel" :disabled="isSaving">キャンセル</button>
      <button class="button is-primary" @click="createRoboTemplate()" :disabled="isSaving">テンプレート化する</button>
    </div>
  </BasicModal>
</template>

<script>
import { mapState } from 'vuex'
import BasicModal from '@/components/Modals/BasicModal'
import controlLogMixin from '@/mixins/controlLogMixin'
import ChatBotTags        from '@/components2/Common/Screen/organisms/ChatBotTags'

export default {
  components: {
    BasicModal,
    ChatBotTags
  },
  mixins: [
    controlLogMixin
  ],
  props: {
    isShowModal: {
      type: Boolean,
      required: true
    },
    chatbot: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      fileName: null,
      isSaving: false,
      description: null
    }
  },
  mounted () {
    this.description = this.chatbot.tmp_description
  },
  watch: {
    isSaving () {
      if (!this.isSaving) this.cancel()
    },
  },
  methods: {
    cancel () {
      this.chatbot.tmp_description = this.description
      this.$emit('cancel')
    },
    createRoboTemplate () {
      this.isSaving = true

      // タグ設定の確認
      if (this.chatbot.tag.length === 0) {
        alert('タグが設定されていません。1つ以上設定してください。')
        this.isSaving = false
        return
      }

      console.log('chatbot=')
      console.log(this.chatbot)

      this.$emit('createRoboTemplate',this.chatbot)
      this.isSaving = false
    },
  }
}
</script>

<style lang="scss" scoped>
.-container {
  padding: 8px;
  height: auto;
  overflow: auto;
}
.input-field {
  padding: 8px;
  text-align: left;
  p {
    font-weight: 600;
    margin-bottom: 2px;
  }
}
.footer-box {
  width: 100%;
  height: 64px;
  border-top: solid thin #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  button {
    width: 47%;
  }
}
.file-name-container {
  display: flex;
  margin-top: 4px;
}
.right-col {
  width: calc(100% - 100px);
  text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/components2/Robo/modal/organisms/ModalCreateRoboTemplate.vue